// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"Yta-z","narrowOptionButtons":"Zta-z","noOptions":"_ta-z"};